import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fromDailyBatchModel',
    /**
     *The pure pipe does not involked when the parameter is a complex object.
     * refer: https://github.com/angular/angular/issues/16595
     * Here model is a complex nested object which will be created at run time,
     * But the structure of the model -ie ({daily: {}, batch: {}) does not change.
     * so pure pipe does not recognize any change
     */
    pure: false,
    standalone: false
})
export class FromDailyBatchModelPipe implements PipeTransform {
	constructor() {
	}

	transform(
		neededValues: string[],
		model: { daily: any; batch: any },
		isBatch: boolean,
		decimalPlaces?: number
	): any {
		if (isBatch) {
			/**
			 * For reporting it is possible that only batch/daily variables are passed,
			 * for components, it is passed as array
			 */
			const variable = Array.isArray(neededValues) ? neededValues[1] : neededValues;
			let batch = model.batch[variable];

			if (decimalPlaces && typeof batch === 'number') {
				return batch.toFixed(decimalPlaces);
			} else {
				return batch;
			}
		} else {
			/**
			 * For reporting it is possible that only batch/daily variables are passed,
			 * for components, it is passed as array
			 */
			const variable = Array.isArray(neededValues) ? neededValues[0] : neededValues
			let daily = model.daily[variable];

			if (decimalPlaces && typeof daily === 'number') {
				return daily.toFixed(decimalPlaces);
			} else {
				return daily;
			}
		}
	}
}
